import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { WorkPermitFormComponent } from './work-permit-form/work-permit-form.component';
import { WorkPermitModalComponent } from './work-permit-modal/work-permit-modal.component';
import { WorkPermitReportComponent } from './work-permit-report/work-permit-report.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OtpModule } from '../otp.module';

@NgModule({
  declarations: [WorkPermitFormComponent, WorkPermitModalComponent, WorkPermitReportComponent] ,
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule,
    OtpModule
  ],
  
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class WorkPremitModule { }
